import styled from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Cell } from '../styles/Grid'
import Image from 'next/image'

const SolutionFeatures = ({ data }: any) =>
  <Wrapper bg={data.background?.[0]?.background}>
    {data.title &&
      <Title>{data.title}</Title>
    }
    {data.image && (
      <Banner>
        <Image
          src={data.image.url}
          alt="Solution Feature Banner"
          layout="fill"
          objectFit="cover"
          quality={75}
          loading="lazy"
          placeholder="blur"
          blurDataURL={`${data.image.url}?width=10&height=10&quality=10`}
        />
      </Banner>
    )}
    {data.items.map((item: any) =>
      <Section key={item._metadata.uid} bg={lighter(data.background?.[0]?.background)}>
        {item.icon && (
          <IconWrapper padding={item.icon_padding || 0}>
            <Image
              src={item.icon.url}
              alt={item.title || 'Feature Icon'}
              width={120}
              height={120}
              quality={75}
              loading="lazy"
            />
          </IconWrapper>
        )}
        <Content>
          <h4>{item.title}</h4>
          {data.style === "Paragraphs" && item.feature.map((feature: any, index: any) =>
            <div key={index} dangerouslySetInnerHTML={{ __html: feature }} />)}
          {data.style !== "Paragraphs" &&
            <ul>
              {item.feature.map((feature: any, index: any) =>
                <li key={index} dangerouslySetInnerHTML={{ __html: feature }} />)}
            </ul>}
        </Content>
      </Section>)}
  </Wrapper>

export default SolutionFeatures

export const Banner = styled.div`
  border-top: 15px transparent solid;
  display: block;
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;

  @media ${breakpoint.desktop} {
    aspect-ratio: 16 / 8;
  }
`

export const Title = styled.h2`
  text-align: center;
  padding: 40px 0;
  font-size: 72px;
  line-height: 80px;
  margin: 100px 0 32px;
`

export const Wrapper = styled(Container) <any>`
  margin: 36px 20px;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 0 auto 140px;
  }
  ${Banner} {
    border-color: ${props => props.bg};
  }
  ${Title} {
    background: ${props => props.bg};
  }
`

export const Content = styled.div`
  flex: 1;
`

const IconWrapper = styled.div<{ padding: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.padding}px;
  max-height: 120px;
  height: 100%;
  @media ${breakpoint.desktop} {
    margin-right: 70px;
  }
`

const Section = styled(Cell)`
  margin: 16px;
  display: flex;
  align-items: center;
  background: ${props => props.bg};
  padding: 20px;
  flex-direction: column;
  @media ${breakpoint.desktop} {
    margin: 32px 0;
    padding: 50px 70px;
    flex-direction: row;
  }
  h4 {
    font-size: 20px;
    line-height: 26px;
    font-style: normal;
    font-weight: 600;
    margin-top: 0;
    text-align: center;
    @media ${breakpoint.desktop} {
      text-align: left;
    }
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
  li {
    margin-bottom: 20px;
    &:last-item {
      margin-bottom: 0;
    }
  }
`

export const Cta = styled.a`
  display: inline-block;
  cursor: pointer;
  background: #000;
  color: white;
  text-transform: uppercase;
  padding: 10px 20px;
  margin-top: 50px;
`